import { applyMiddleware, CombinedState, compose, createStore, Store } from 'redux';

import { reduxRootTypes } from 'src/types';
import logger from 'redux-logger';
import { rootReducer } from './reducers/root.reducer';

let store: Store<CombinedState<reduxRootTypes.RootStateType>, any>;

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const configureStore = (): Store<CombinedState<reduxRootTypes.RootStateType>, any> => {
  // const composed: any[] = [applyMiddleware(logger)];
  const composed: any[] = [applyMiddleware()];

  store = createStore(rootReducer, undefined, compose(...composed));

  return store;
};

const getStore = () => {
  return store;
};

export { configureStore, getStore };
